export function clock(el, 
  { 
    format = '24',
    timezone = 'Europe/London',
    showTimezone = true,
    seperator = ':',
  } = {}) {
  const hourContainer = document.createElement('span');
  const minuteContainer = document.createElement('span');
  const timezoneContainer = document.createElement('span');
  let oldTime = {}; 
  createClockElements();
  loop();
  setInterval(() => loop(), 5000);

  el.addEventListener('click', function() {
    el.classList.toggle('inverted');
  });

  function loop() {
    const newTime = getCurrentTime();
    if (oldTime.minute !== newTime.minute) {
      updateTime(newTime);
    }
    oldTime = newTime;
  }

  function getCurrentTime(time = new Date()) {
    let hour = time.toLocaleString([], {
      timeZone: timezone, 
      hour: 'numeric', 
      hour12: '24' ? false : true,
    });
    let minute = time.toLocaleString([], {
      timeZone: timezone, 
      minute: '2-digit',
    });

    minute = Number(minute) >= 10 ? minute : '0' + Number(minute);

    let timezoneAbbr = time.toLocaleString([], {
      timeZone: timezone,
      timeZoneName: 'short',
    }).split(' ')[2];

    if (format === '12') {
      const mid = Number(hour) >= 12 ? 'pm' : 'am';
      minute = minute + '' + mid;
      hour = Number(hour) > 12 ? String(Number(hour)) - 12 : Number(hour);
    }
    return {
      hour: hour,
      minute: minute, 
      timezoneAbbr: showTimezone ? timezoneAbbr : '',
    }
  }

  function updateTime(time) {
    hourContainer.innerText = time.hour;
    minuteContainer.innerText = time.minute;
    timezoneContainer.innerText = ' ' + time.timezoneAbbr;
  }
  
  function createClockElements() {
    const seperatorContainer = document.createElement('span');
    hourContainer.classList.add('clock__hour');
    minuteContainer.classList.add('clock__minute');
    seperatorContainer.classList.add('clock__seperator');
    seperatorContainer.innerText = seperator;
    el.appendChild(hourContainer);
    el.appendChild(seperatorContainer);
    el.appendChild(minuteContainer);

    if (showTimezone) {
      el.appendChild(timezoneContainer);
    }
  }
}
